import React from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Button,
  Alert,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroupButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormFeedback,
  CustomInput,
  Tooltip,
  UncontrolledTooltip
} from 'reactstrap';
import Select, { components } from "react-select";
import jQuery from 'jquery'

import { getCurrentUser, authenticateLoggedIn, addHeaderTitle, getParameterByName, authenticateLoginpage, addBreadcrumb } from '../../services/parse';
import { updateRecord, checkFieldValid, fetchRecordById, getImagesList, deleteImagesList } from '../../services/region';
import withRouter from '../../components/common/WithRouter';

var Parse = require('parse');

class editRegion extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
      collapse: true,
      fadeIn: true,
      timeout: 300,
      isSuper: '',
      addedclass: 'd-none',
      recordByIdData: [],
      countryData: [],
      imagesById: [],
      isEdit: false,
      logofile: null,
      rewardsfile: null,
      loginlogofile: null,
    };
  }


  async componentDidMount(evt) {
    //auth start
    authenticateLoggedIn();
    addHeaderTitle('Edit Region');
    addBreadcrumb('Home / Regions / Edit Region');

    // var editobjectid = getParameterByName('objectid');
    var editobjectid = this.props.params.objectid;

    if (editobjectid) {
      fetchRecordById({ objectid: editobjectid }).then((value) => {
        if (value.length > 0) {
          this.setState({ recordByIdData: value[0] });
          this.setState({ isEdit: true });


        } else {
          this.setState({ isEdit: false });
        }
      });


      // getImagesList(editobjectid).then((value) => {
      //   this.setState({ imagesById: value });
      // });

    }

  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  handleChange(event) {
    if (!event.target.files) return;
    var selDiv = jQuery('#selectedFiles');
    selDiv.html('');

    var files = event.target.files;
    for (var i = 0; i < files.length; i++) {
      var f = files[i];
      selDiv.append(f.name + "<br/>");
    }
  }




  updateRecord = () => {

    var valid = checkFieldValid('add');
    if (valid !== false) {
      jQuery('#addbutton').prop('disabled', true);

      var hiddenrecordid = jQuery('#hiddenrecordid').val();

      var name = jQuery('#bname').val();
      var description = jQuery('#bdescription').val();
      var status = jQuery('#status').val();



      // var multipleimage = jQuery('#multipleimage');
      // var files = multipleimage.prop('files');
      // var imagefiles = [];
      // if (files.length > 0) {
      //   for (var i = 0; i < files.length; i++) {
      //     var galleryfile = files[i];
      //     var parseFile = new Parse.File("assets.png", galleryfile);
      //     if (parseFile) {
      //       parseFile.save();
      //       imagefiles[i] = parseFile;
      //     }
      //   }

      //   jQuery('#loadingtag').removeClass('d-none');
      //   jQuery('#loadingtag').addClass('d-block');
      // }






      updateRecord({ edithiddenid: hiddenrecordid, name: name, description: description, status: status }).then((value) => {
        if (value === true) {
          this.setState({ addedclass: 'd-block' });

          // getImagesList(hiddenrecordid).then((value) => {
          //   this.setState({ imagesById: value }); 
          // });

          // var selDiv = jQuery('#selectedFiles');
          // selDiv.html('');

          // jQuery('#loadingtag').addClass('d-none');
          // jQuery('#loadingtag').removeClass('d-block');
        } else {
          this.setState({ addedclass: 'd-none' });
        }

        // jQuery('#addform').trigger("reset");
        jQuery('#addbutton').prop('disabled', false);
      });

    }
  }

  setDeleteGallery = (event) => {

    let searchParams = new URLSearchParams(window.location.search);
    let editobjectid = searchParams.get('objectid');

    var objectId = jQuery(event.currentTarget).data('target');

    const r = window.confirm("Do you really want to Delete?");
    if (r === true) {
      var dlt = deleteImagesList(objectId);
      if (dlt === true) {
        // jQuery(event.target).parent().css('display', 'none');

        getImagesList(editobjectid).then((value) => {
          this.setState({ imagesById: value });
        });

      }
    }
  }





  render() {
    return <div>

      {this.state.isEdit === true ?
        <div>
          <Row className="justify-content-between topbuttonbar">
            <Col className="col-md-5">
              <Alert color="success" className={this.state.addedclass}>
                Record Updated
                    <Link to="/region/region" className="float-right">
                  &nbsp; Go to list
                    </Link>
              </Alert>
            </Col>
            <Col className="col-auto mb-4">
              <Link to="/region/region" className="btn btn-primary btncancle mr-3">
                <span className="border-left pl-2">Cancel</span>
              </Link>
              <Button type="button" color="primary" id="addbutton" onClick={this.updateRecord}>
                <span className="border-left pl-2"></span>
                Save
              </Button>
            </Col>
          </Row>

          <Row>

            <Col md="5">
              <Card>
                <CardTitle>
                  <i className="icon-circle icon-pencil"></i>
                  Edit Region
                </CardTitle>
                <CardBody>





                  <Form id="addform">
                    <Input type="hidden" id="hiddenrecordid" defaultValue={this.state.recordByIdData.id} />
                    <FormGroup className="form-group">
                      <Label htmlFor="name">Name</Label>

                      <Input type="text" name="bname" id="bname" defaultValue={this.state.recordByIdData.get('name')} />
                    </FormGroup>


                    <FormGroup className="form-group">
                      <Label htmlFor="country">Status</Label>
                      <select name="status" id="status" className="form-control" defaultValue={String(this.state.recordByIdData.get('status'))}>
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                      </select>
                    </FormGroup>

                    <FormGroup className="form-group">
                      <Label htmlFor="description">Description </Label>

                      <Input type="textarea" name="bdescription" id="bdescription" rows="5" placeholder="Add your comments here..." defaultValue={this.state.recordByIdData.get('description')} />
                    </FormGroup>


                    {/* Images area */}


                    {/* {
                      this.state.imagesById.map((imageData, gallerykey) =>
                        <div className="galleryitem" key={gallerykey}>
                          <img src={imageData.get('image').url()} alt="Gallery Image" width="100" />
                          <button data-target={imageData.id} type="button" className="btn btn-danger deletebutton customshow" onClick={this.setDeleteGallery.bind(this)}>
                            x
                          </button>
                        </div>
                      )

                    }



                    <input id="multipleimage" type="file" onChange={this.handleChange.bind(this)} multiple />
                    <div id="selectedFiles"></div>
                    <p id="loadingtag" className="d-none">Please wait, images processing...</p> */}



                  </Form>
                </CardBody>
              </Card>

            </Col>
          </Row>
        </div>
        :
        <p></p>
      }

    </div>
  }
}

export default withRouter(editRegion);
